import { render } from "./JobToAdd.vue?vue&type=template&id=bfa1bcc8&scoped=true"
import script from "./JobToAdd.vue?vue&type=script&lang=js"
export * from "./JobToAdd.vue?vue&type=script&lang=js"

import "./JobToAdd.vue?vue&type=style&index=0&id=bfa1bcc8&scoped=true&lang=scss"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/deguild-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfa1bcc8"]])

export default __exports__